import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import useSound from 'use-sound'
import cta from '../assets/videos/cta.webm'
import ctaFr from '../assets/videos/cta-fr.webm'
import click from '../assets/sfx/click.webm'

import MasterLayout from '../layout/Master'
import LanguageToggle from '../components/LanguageToggle'

const Home = () => {
  const navigate = useNavigate()
  const { i18n } = useTranslation()

  const [playClick] = useSound(click, { volume: 0.2 })

  useEffect(() => {
    const kioskId = localStorage.getItem('kiosk-id')

    const urlParams = new URLSearchParams(window.location.search)
    const deluxe = urlParams.get('d')
    const sample = urlParams.get('s')

    localStorage.removeItem('reset')
    localStorage.removeItem('gift')

    localStorage.setItem('kiosk-id', kioskId)

    if (deluxe) localStorage.setItem('numOfDeluxe', deluxe)
    if (sample) localStorage.setItem('numOfSample', sample)
  }, [])

  useEffect(() => {
    localStorage.setItem('lang', i18n.language)
  }, [])

  const goNext = () => {
    playClick()

    navigate('/instruction')
  }

  return (
    <MasterLayout>
      <div onClick={goNext} className="relative cursor-pointer">
        {i18n.language === 'en' ? (
          <video
            src={cta}
            autoPlay
            loop
            muted
            hwz="z-index:-1"
            playsInline
            className="w-[100%] h-screen"
            
          />
        ) : (
          <video
            src={ctaFr}
            autoPlay
            loop
            muted
            hwz="z-index:-1"
            playsInline
            className="w-[100%] h-screen"
          />
        )}
      </div>
    </MasterLayout>
  )
}

export default Home
